import React from 'react'

import styled from 'styled-components'

// theme
import aampeTheme from '../../constants/aampeTheme'

import { createShouldForwardProp } from 'helpers/shouldForwardProp'

// components
import ErrorAlert from '../errors/ErrorAlert'
import GenericSpinner from '../nav/GenericSpinner'

const shouldForwardProps = createShouldForwardProp(['isActive'])
export default function ToggleInput({
    isActive,
    toggleIsActive,
    isLoading,
    isError,
    disabled,
    width = 36,
}) {
    const handleClick = () => {
        if (!disabled) {
            toggleIsActive()
        }
    }

    const height = (20 * width) / 36

    return (
        <>
            {isLoading ? (
                <Toggle>
                    <GenericSpinner size={16} />
                </Toggle>
            ) : isError ? (
                <ErrorAlert title={'Error'} />
            ) : (
                <ActiveToggle
                    isActive={isActive}
                    onClick={handleClick}
                    style={
                        disabled ? { opacity: 0.4, pointerEvents: 'none' } : {}
                    }
                    width={width}
                    height={height}
                >
                    <ActiveInactive
                        isActive={isActive}
                        height={height}
                        width={width}
                    />
                </ActiveToggle>
            )}
        </>
    )
}

const Toggle = styled.div({
    borderRadius: '50px',
    width: '36px',
    padding: aampeTheme.spacing4(0.25),
    cursor: 'pointer',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: aampeTheme.colors.solidWG01,
})

const ActiveToggle = styled.div.withConfig({
    shouldForwardProp: shouldForwardProps,
})((props) => ({
    backgroundColor: props.isActive
        ? aampeTheme.colors.solidA01
        : aampeTheme.colors.solidWG01,
    borderRadius: '50px',
    width: `${props.width}px`,
    padding: aampeTheme.spacing4(0.25),
    cursor: 'pointer',
    height: `${props.height}px`,
    display: 'flex',
    alignItems: 'center',
    border: props.isActive ? 'none' : '',
    transition: 'background-color 200ms ease-in-out',

    '&:hover': {
        backgroundColor: props.isActive
            ? aampeTheme.colors.solidA02
            : aampeTheme.colors.solidWG02,
    },
}))
const ActiveInactive = styled.div.withConfig({
    shouldForwardProp: shouldForwardProps,
})((props) => ({
    backgroundColor: aampeTheme.colors.white,
    borderRadius: '50px',
    width: `${props.height - 4}px`,
    height: `${props.height - 4}px`,
    boxShadow: `${
        !props.isActive
            ? `0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)`
            : ''
    }`,
    marginLeft: props.isActive ? `${props.width - props.height + 1}px` : '',
}))
